export default {
  methods: {
    goToForgetPassword(e) {
      this.$emit("changeView", 4);
    },
    volverInicioSesion(e) {
      this.$emit("showFirst", true);
      this.$emit("changeView", 1);
    },
  },
};
